import { useState, useEffect } from "react";
import MyPatient from "./MyPatient";
import MyConsultations from "./MyConsultations";
import PatientRequests from "../Components/PatientRequests";
import MyOPDs from "../Components/MyOPDs";
import { useLocation, useNavigate } from "react-router";

const Home = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    // Get tab from URL query parameter, default to "Patients"
    const getTabFromURL = () => {
        const params = new URLSearchParams(location.search);
        return params.get("tab") || "Patients";
    };

    const [selectedTab, setSelectedTab] = useState(getTabFromURL());

    // Update URL when tab changes
    const handleTabChange = (tab) => {
        setSelectedTab(tab);
        navigate(`?tab=${tab}`, { replace: true });
    };

    // Sync with URL when browser back/forward is used
    useEffect(() => {
        setSelectedTab(getTabFromURL());
    }, [location.search]);

    const renderContent = () => {
        switch (selectedTab) {
            case "Patients":
                return <MyPatient />;
            case "Consultations":
                return <MyConsultations />;
            case "PatientRequests":
                return <PatientRequests />;
            case "UpcomingOPD":
                return <MyOPDs/>
            default:
                return null;
        }
    };

    return (
        <div className="pt-16 flex min-h-screen bg-gray-50">
            {/* Sidebar */}
            <div className="w-64 bg-white/80 backdrop-blur-md border-r shadow-sm p-6 flex flex-col fixed h-full">
                <h2 className="text-2xl font-bold text-green-700 mb-8">Dashboard</h2>

                {/* Menu Items */}
                <div className="flex flex-col space-y-2">
                    <button
                        onClick={() => handleTabChange("Patients")}
                        className={`px-4 py-2 rounded-lg text-left font-medium transition-all
                        ${selectedTab === "Patients"
                                ? "bg-green-600 text-white shadow-md scale-[1.02]"
                                : "text-gray-700 hover:bg-gray-100"
                            }`}
                    >
                        My Patients
                    </button>

                    <button
                        onClick={() => handleTabChange("Consultations")}
                        className={`px-4 py-2 rounded-lg text-left font-medium transition-all
                        ${selectedTab === "Consultations"
                                ? "bg-green-600 text-white shadow-md scale-[1.02]"
                                : "text-gray-700 hover:bg-gray-100"
                            }`}
                    >
                        My Consultations
                    </button>

                    <button
                        onClick={() => handleTabChange("PatientRequests")}
                        className={`px-4 py-2 rounded-lg text-left font-medium transition-all
                        ${selectedTab === "PatientRequests"
                                ? "bg-green-600 text-white shadow-md scale-[1.02]"
                                : "text-gray-700 hover:bg-gray-100"
                            }`}
                    >
                        Patients Requests
                    </button>
                    <button
                        onClick={() => handleTabChange("UpcomingOPD")}
                        className={`px-4 py-2 rounded-lg text-left font-medium transition-all
                        ${selectedTab === "UpcomingOPD"
                                ? "bg-green-600 text-white shadow-md scale-[1.02]"
                                : "text-gray-700 hover:bg-gray-100"
                            }`}
                    >
                        My OPDs
                    </button>
                </div>
            </div>

            {/* Right Content Area */}
            <div className="flex-1 ml-64 p-6">
                {renderContent()}
            </div>
        </div>
    );
};

export default Home;
